<template>
  <!-- ケアオーケストレーターディーラー申請一覧 -->
  <div id="CODealerRequestList">
    <div id="container-center">
      <requestListContent/>
    </div>
    <div style="margin-top:10px;">
        <b-button class="backbutton is-primary" @click="back">戻る</b-button>
    </div>
  </div>
</template>

<script>
import contents from "@/components/mock/guest/careorchestrator/setting/CORequestList";

export default {
  name: "CODealerRequestList",
  methods: {
    back:  function() {
      this.$router.go(-1);
    },
  },
  data() {
    return {
    };
  },
  filters: {},
  components: {
    requestListContent: contents
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/CODealerRequestList.vue